<ion-list
    [attr.data-test]="'Automation.mdl-data-registered' | translate" mode="ios" lines="none" class="list-content">
  <ion-item lines="none" mode="md" color="transparent" class="ion-text-center">
    <ion-label
      [attr.data-test]="'Automation.txt-data-registered-title' | translate"
      mode="md"
      color="status-icon-enable"
      class="mpe-font-weight-600 recorded-data"
    >
      {{ 'Titles.recorded-data' | translate }}
    </ion-label>
  </ion-item>

  <!-- ? Imagen -->
  <ion-item lines="none" mode="md" color="transparent">
    <ion-icon name="warning-outline" color="danger" class="warning"></ion-icon>
  </ion-item>

  <!-- * Descripción -->
  <ion-item lines="none" mode="md" color="transparent" class="ion-text-center" >
    <ion-label
      [attr.data-test]="'Automation.txt-data-registered-data' | translate"
      mode="md"
      color="status-icon-enable"
      class="do-you-recognize-number"
      [innerHTML]=" 'Labels.do-you-recognize-number' | translate: componentProps | htmlSeguro"
    >
    </ion-label>
  </ion-item>

  <!-- ? Botones Contraseña -->
  <ion-item lines="none" mode="md" color="transparent" class="item-button">
    <ion-button
      [attr.data-test]="'Automation.btn-data-registered-pass-rec' | translate" 
      size="default" mode="md" color="tpcta" (click)="onClick(true)">
      <ion-label mode="md">
        {{ 'Buttons.recover-password' | translate }}
      </ion-label>
    </ion-button>
  </ion-item>

  <!-- ? Botones Reseteo -->
  <ng-container *ngIf="('Miscellaneous.view-reset-modal' | translate)">
    <ion-item lines="none" mode="md" color="transparent" class="item-button">
      <ion-button
        [attr.data-test]="'Automation.link-data-registered-accnt-rec' | translate" 
        class="mpe-button-link-line"
        size="default"
        mode="md"
        fill="clear"
        color="darkblue"
        (click)="onClick(false)"
      >
        <ion-label mode="md">
          {{ 'Buttons.recover-account' | translate }}
        </ion-label>
      </ion-button>
    </ion-item>

    <!-- * Descripción -->
    <ion-item
      lines="none"
      mode="md"
      color="transparent"
      class="ion-text-center item-footer"
    >
      <ion-label
        [attr.data-test]="'Automation.txt-data-registered-footer' | translate" 
        mode="md"
        color="status-icon-enable"
        class="recovering-account-unlink-data-will-keep-activity"
      >
        {{ 'Labels.recovering-account-unlink-data-will-keep-activity' |
        translate }}
      </ion-label>
    </ion-item>
  </ng-container>
</ion-list>
